<template>
  <div>
    <img class="crisp-image" src="@/assets/images/ico058.svg" alt="Show Reference Code">
    <text-string label-id="txt372" class="m-b-10"/>
    <text-string label-id="txt1420"/>
  </div>
</template>

<script>
  export default {
    name: "modal-view-hipres-step-two"
  }
</script>

<style scoped>

</style>